import { DEFAULT_HOME_HIGHLIGHTS, normalizeHomeHighlights } from "./homeHighlights";

export { DEFAULT_HOME_HIGHLIGHTS, normalizeHomeHighlights };

export const DEFAULT_HERO_IMAGE =
    "https://static.prod-images.emergentagent.com/jobs/29a5b8f3-d19d-49ef-b87c-dbb3b6bf2cd6/images/12ad44a63e06dc146dea958780ef6bd93423b3c6e17d76cc7fbbcc5861849e2f.png";

export const DEFAULT_HOME_HERO = {
    badge: "Desde 1992",
    line1: "Construye",
    line2_prefix: "con",
    line2_highlight: "poder",
    line3: "Sin compromiso.",
    subtitle:
        "Herramientas, materiales y equipo profesional de las mejores marcas. Todo lo que tu obra necesita en un solo lugar.",
    cta_primary_label: "Ver Catálogo",
    cta_primary_url: "/productos",
    cta_secondary_label: "Destacados",
    cta_secondary_url: "/productos?featured=1",
    image_url: DEFAULT_HERO_IMAGE,
    image_alt: "Trabajador de construcción",
    card_label: "Marca destacada",
    card_text: "Truper · DeWalt",
};

export const DEFAULT_HOME_STATS = [
    { value: "32+", label: "Años de experiencia" },
    { value: "5,000+", label: "Productos en stock" },
    { value: "120+", label: "Marcas disponibles" },
    { value: "48h", label: "Envío nacional" },
];

export const DEFAULT_MARQUEE_BRANDS = [
    "Truper", "DeWalt", "Comex", "CEMEX", "Foset", "Bticino", "Condumex", "Deacero", "Cresco",
];

export function normalizeHomeHero(raw) {
    const h = { ...DEFAULT_HOME_HERO, ...(raw || {}) };
    return {
        badge: String(h.badge || DEFAULT_HOME_HERO.badge).trim(),
        line1: String(h.line1 || DEFAULT_HOME_HERO.line1).trim(),
        line2_prefix: String(h.line2_prefix ?? DEFAULT_HOME_HERO.line2_prefix).trim(),
        line2_highlight: String(h.line2_highlight || DEFAULT_HOME_HERO.line2_highlight).trim(),
        line3: String(h.line3 || DEFAULT_HOME_HERO.line3).trim(),
        subtitle: String(h.subtitle || DEFAULT_HOME_HERO.subtitle).trim(),
        cta_primary_label: String(h.cta_primary_label || DEFAULT_HOME_HERO.cta_primary_label).trim(),
        cta_primary_url: String(h.cta_primary_url || DEFAULT_HOME_HERO.cta_primary_url).trim() || "/productos",
        cta_secondary_label: String(h.cta_secondary_label || DEFAULT_HOME_HERO.cta_secondary_label).trim(),
        cta_secondary_url: String(h.cta_secondary_url || DEFAULT_HOME_HERO.cta_secondary_url).trim() || "/productos?featured=1",
        image_url: String(h.image_url || DEFAULT_HOME_HERO.image_url).trim(),
        image_alt: String(h.image_alt || DEFAULT_HOME_HERO.image_alt).trim(),
        card_label: String(h.card_label || DEFAULT_HOME_HERO.card_label).trim(),
        card_text: String(h.card_text || DEFAULT_HOME_HERO.card_text).trim(),
    };
}

export function normalizeHomeStats(raw) {
    if (!Array.isArray(raw) || raw.length === 0) return [...DEFAULT_HOME_STATS];
    return raw.map((s, idx) => {
        const fb = DEFAULT_HOME_STATS[idx] || { value: "", label: "" };
        return {
            value: String(s?.value ?? fb.value).trim(),
            label: String(s?.label ?? fb.label).trim(),
        };
    }).filter((s) => s.value || s.label);
}

export function normalizeMarqueeBrands(raw) {
    if (Array.isArray(raw) && raw.length > 0) {
        return raw.map((b) => String(b).trim()).filter(Boolean);
    }
    if (typeof raw === "string" && raw.trim()) {
        return raw.split(/[,|]/).map((b) => b.trim()).filter(Boolean);
    }
    return [...DEFAULT_MARQUEE_BRANDS];
}

/** Une campos planos del formulario/API en objeto home_hero */
export function buildHomeHeroFromSettings(s) {
    if (!s) return normalizeHomeHero(null);
    if (s.home_hero && typeof s.home_hero === "object") {
        return normalizeHomeHero(s.home_hero);
    }
    return normalizeHomeHero({
        badge: s.home_hero_badge,
        line1: s.home_hero_line1,
        line2_prefix: s.home_hero_line2_prefix,
        line2_highlight: s.home_hero_line2_highlight,
        line3: s.home_hero_line3,
        subtitle: s.home_hero_subtitle,
        cta_primary_label: s.home_hero_cta_primary_label,
        cta_primary_url: s.home_hero_cta_primary_url,
        cta_secondary_label: s.home_hero_cta_secondary_label,
        cta_secondary_url: s.home_hero_cta_secondary_url,
        image_url: s.home_hero_image_url,
        image_alt: s.home_hero_image_alt,
        card_label: s.home_hero_card_label,
        card_text: s.home_hero_card_text,
    });
}

export function flattenHomeHeroForSave(hero) {
    const h = normalizeHomeHero(hero);
    return {
        home_hero_badge: h.badge,
        home_hero_line1: h.line1,
        home_hero_line2_prefix: h.line2_prefix,
        home_hero_line2_highlight: h.line2_highlight,
        home_hero_line3: h.line3,
        home_hero_subtitle: h.subtitle,
        home_hero_cta_primary_label: h.cta_primary_label,
        home_hero_cta_primary_url: h.cta_primary_url,
        home_hero_cta_secondary_label: h.cta_secondary_label,
        home_hero_cta_secondary_url: h.cta_secondary_url,
        home_hero_image_url: h.image_url,
        home_hero_image_alt: h.image_alt,
        home_hero_card_label: h.card_label,
        home_hero_card_text: h.card_text,
    };
}
